import { render } from "./associationAdd.vue?vue&type=template&id=78cedd64&scoped=true"
import script from "./associationAdd.vue?vue&type=script&lang=js"
export * from "./associationAdd.vue?vue&type=script&lang=js"

import "./associationAdd.vue?vue&type=style&index=0&id=78cedd64&lang=scss&scoped=true"
import "./associationAdd.vue?vue&type=style&index=1&id=78cedd64&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78cedd64"]])

export default __exports__